/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Select_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Select commit snapshot" |
*
* @param {Snapshot_History_Select_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_select_aria_label = /** @type {((inputs?: Snapshot_History_Select_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Select_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner un snapshot de commit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Snapshot-Speicherung auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona l'istantanea del commit")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите снимок коммита")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar instantánea de confirmación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择提交快照")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コミットスナップショットを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कमिट स्नैपशॉट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione \"Confirmar snapshot\"")
	return /** @type {LocalizedString} */ ("Select commit snapshot")
});